import { Class} from '../utils'
import icons from '../resources/icons'
import { createButton } from './ThemeResult'


export default Class (
  /** @lends DetailsContent# */
  {
    resultActionListeners: null,

    initialize: function(){
      jQuery( document ).ready(() => {
        jQuery.getScript("https://widget.cdn.septima.dk/1.29.2/widgetapi.js");
      });
    },

    setResultActionListeners: function(listeners){
      this.resultActionListeners = listeners;
    },

    formatListHeader: function(options){
      return this.formatArea({
        icon: options.icon,
        value: options.title,
        islistheader: true 
      });
    },
	
    formatButton: function(options){
      return this.formatArea({
        icon: options.icon,
        value: options.title,
        clickable: true,
        islistitem: options.islistitem ? options.islistitem : false 
      });
    },
	
    formatTextArea: function(options){
      return this.formatArea({
        icon: options.icon,
        value: options.text,
        islistitem: options.islistitem ? options.islistitem : false
      });
    },
	
    formatLabelValue: function(options){
      return this.formatArea({
        icon: options.icon,
        label: options.label,
        value: options.value,
        islistitem: options.islistitem ? options.islistitem : false
      });
    },
	
    formatLink: function(options){
      const area = this.formatArea({
        icon: options.icon,
        value: options.linkTitle,
        fixedIcons: options.fixedIcons,
        liveIcons: options.liveIcons,
        label: options.label,
        clickable: true,
        islistitem: options.islistitem ? options.islistitem : false
      });
      area.click(()=>{window.open(options.link);});
      return area;
    },
    
    formatMap: function (options) {
      let area = jQuery("<div>");
      new WidgetAPI(area, options.mapOptions);
      return area;
    },

    formatItems: function(items){
      let list = jQuery();
      let item;
      let area;
      if (items.length > 0 ){
        item = items[0];
        area = this.formatItem(item);
        list = area; 
      }
      for (let i=1; i<items.length; i++){
        item = items[i];
        area = this.formatItem(item);
        list = list.add(area); 
      }
      return list;
    },
	
    formatList: function(listItems){
      //Indented items
      let list = jQuery();
      let listItem;
      let area;
      if (listItems.length > 0 ){
        listItem = listItems[0];
        area = this.formatItem(listItem, true);
        list = area; 
      }
      for (let i=1; i<listItems.length; i++){
        listItem = listItems[i];
        area = this.formatItem(listItem, true);
        list = list.add(area); 
      }
      return list;
    },
	
    formatItem: function(listItem, isListItemArg){
      let isListItem = (typeof listItem.isListItem !== 'undefined') ? listItem.isListItem :  (isListItemArg ? isListItemArg : false);
      let area;
      if (listItem.type == "labelvalue"){
        area = this.formatLabelValue({
          icon: listItem.icon,
          label: listItem.label,
          value: listItem.value,
          islistitem: isListItem
        });
      } else if (listItem.type === "link"){
        listItem.islistitem = isListItem;
        area = this.formatLink(listItem);
        /*
        area = this.formatLink({
          icon: listItem.icon,
          link: listItem.link,
          linkTitle: listItem.linkTitle,
          islistitem: isListItem
        });
        */
      } else if (listItem.type === "textarea"){
        listItem.islistitem = isListItem;
        area = this.formatTextArea(listItem);
      } else if (listItem.type === "area"){
        listItem.islistitem = isListItem;
        area = this.formatArea(listItem);
      } else if (listItem.type === "listheader"){
        area = this.formatListHeader(listItem);
      } else if (listItem.type === "button"){
        area = this.formatButton({
          icon: listItem.icon,
          title: listItem.title,
          islistitem: isListItem 
        });
      } else if (listItem.type === "jquery-dom-object"){
        area = listItem.object;
      }else if (listItem.type === "image"){
        area = this.formatImage(listItem);
      } else if(listItem.type === "map"){
        area = this.formatMap(listItem);
      }
      return area;
    },

    formatImage: function(options){
      let area = jQuery("<div class='ssDetailsGrid'>");
      if (typeof options.icon !== 'undefined'){
        area = area.append (this.createIconCol(options.icon));
        let value = jQuery("<div class='ssValue'></div>");
        value.append(this.createImageCol(options.value, options.label));
        area = area.append (value);
      }else{
        let value = jQuery("<div class='ssValue'></div>");
        value.append(this.createImageCol(options.value, options.label));
        area = area.append (value);
        area.addClass("ssListIndent");
      }
      return area;
    },

    createImageCol: function(url){
      let image = jQuery("<img src='" + url + "'/>");
      return image;
    },

    formatArea: function(options){
      // Basale layout  
      //options: {icon:, label, value, liveIcons, fixedIcons, truncate, hoverable, clickable, islistitem, islistheader}
      let area = jQuery("<div class='ssDetailsGrid'>");
		
      if (typeof options.icon !== 'undefined'){
        area = area.append (this.createIconCol(options.icon));
      }

      if (options.label){
        let label;
        if (options.label instanceof jQuery){
          label = jQuery("<div class='ssLabel'></div>");
          label.append(options.label);
        }else{
          label = jQuery("<div class='ssLabel'>" + options.label + "</div>");
          label.attr( "title", options.label );
        }
        if (options.truncate){
          label.addClass("ssTruncate");
        }
        area = area.append (label);
      }
      let value = jQuery("<div class='ssValue'></div>");
      if (options.value){
        if (options.value instanceof jQuery){
          value.append(options.value);
        }else{
          value = jQuery("<div class='ssValue'>" + options.value + "</div>");
          value.attr( "title", options.value );
        }
        if (options.truncate){
          value.addClass("ssTruncate");
        }
      }
      area = area.append (value);
		
      if (options.liveIcons){
        for (let i=0; i<options.liveIcons.length; i++){
          let liveIcon = this.createIconCol(options.liveIcons[i]);
          liveIcon.addClass("ssGhostBtn");
          area = area.append (liveIcon);
        }
      }
      if (options.hoverable){
        area.addClass("ssHoverable");
        if (options.result){
          area.hover(
            ()=>{this.resultHover(options.result);},
            ()=>{this.resultHover(null);}
          );

          if (options.result.searcher && !options.result.searcher.hasdetailHandlerDefs(options.result)){
            let ch = options.result.searcher.getCustomButtonDefs(options.result);

            for (let i=0; i<ch.length; i++){
              let button = createButton(options.result, ch[i]);
              let iconCol = this.createIconCol(button);
              iconCol.addClass("ssGhostBtn");
              area = area.append (iconCol);
            }

          }
          let focusIcon = jQuery('<img src="' + icons.globe + '">');
          focusIcon.click(()=>{
            this.resultFocus(options.result);
            return false;
          });
          const focusIconCol = this.createIconCol(focusIcon);
          focusIconCol.addClass("ssFixedBtn");
          area = area.append (focusIconCol);
        }
      }

      if (options.fixedIcons){
        for (let j=0; j<options.fixedIcons.length; j++){
          let fixedIcon = this.createIconCol(options.fixedIcons[j]);
          fixedIcon.addClass("ssFixedBtn");
          area = area.append (fixedIcon);
        }
      }
		
      if (options.clickable){
        area.addClass("ssClickable");
        if (options.result){
          if (options.result.searcher && options.result.searcher.hasdetailHandlerDefs(options.result)){
            let detailsIcon = jQuery('<img src="' + icons.list.detailsIcon + '">');
            let detailsIconCol = this.createIconCol(detailsIcon);
            detailsIconCol.addClass("ssFixedBtn");
            area = area.append (detailsIconCol);
          }
          area.click(()=>{this.selectResult(options.result);});
        }
      }
      if (options.islistitem){
        area.addClass("ssListItem");
      } else{
        if (typeof options.icon === 'undefined'){
          area.addClass("ssListIndent");
        }
        if (options.islistheader){
          area.addClass("ssHeader");
        }
      }
		
      return area;
    },
	
    createIconCol: function(icon){
      let iconCol = jQuery();
      if (typeof icon !== 'undefined'){
        iconCol = jQuery("<div class='ssIcon'>");
        if (icon instanceof jQuery){
          iconCol.append(icon);
        }else{
          iconCol.append(jQuery('<img src="' + icon + '" />'));
        }
      }
      return iconCol;
    },
	
    selectResult: function(result){
      if (this.resultActionListeners){
        this.resultActionListeners.hover(null);
        this.resultActionListeners.select(result);
      }
    },
	
    resultHover: function (result) {
      if (this.resultActionListeners){
        this.resultActionListeners.hover(result);
      }
    },
	
    resultFocus: function (result) {
      if (this.resultActionListeners){
        this.resultActionListeners.hover(null);
        this.resultActionListeners.focus(result);
      }
    },
		
    CLASS_NAME: 'DetailItemsRenderer'

  });
